// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610051614/js/" + chunkId + "." + {"44":"61892599","225":"57d131b5","481":"5f9a4dfc","486":"d95b97c0","770":"7156d1af"}[chunkId] + ".0.8291416269598433.chunk.js";
};